import { render, staticRenderFns } from "./Market.vue?vue&type=template&id=37a26ae2&scoped=true&lang=pug"
import script from "./Market.vue?vue&type=script&lang=js"
export * from "./Market.vue?vue&type=script&lang=js"
import style0 from "./Market.vue?vue&type=style&index=0&id=37a26ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a26ae2",
  null
  
)

export default component.exports